import React from 'react';
import type { LayerRenderer } from '../../../types';
import PolygonSymbolEditor from './PolygonSymbolEditor';

/**
 * POLYGON symbology only — fill and outline colour.
 *
 * Deliberately contains NO symbol gallery, no point size and no rotation.
 * A polygon is represented by its fill and outline, not by an icon.
 */
export default function PolygonSymbologyPanel({
  renderer,
  onChange,
}: {
  renderer: LayerRenderer;
  onChange: (changes: Partial<LayerRenderer>) => void;
}) {
  return <PolygonSymbolEditor renderer={renderer} onChange={onChange} />;
}
